<div class="main-block">
  <div class="main-search">
    <div class="black-wrapper"></div>
    <div class="front-wrapper">
      <h1>Find and book local<br>allied health practitioners</h1>
      <!-- <app-search-box *ngIf="documentSize > 1100" label="city_name, state_name" [minDate]="todayDate"></app-search-box>
      <div class="search-box-group" *ngIf="documentSize <= 1100">
        <app-search-box-common></app-search-box-common>
      </div> -->
    </div>
  </div>
</div>
